export default {"src":"https://cdn.jetlend.ru/_next/static/media/plus-icon.f9fdc7ce.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};